module.exports = __webpack_public_path__ + "static/img/logo.6e9bb5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 34